module.exports = __webpack_public_path__ + "img/ungoodsphoto.png?v=2a5b191a";